import React from 'react';
import { TiTimes } from 'react-icons/ti';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Box, Button, Text } from '@tq/ui-components';

import { GenericValueLabel } from 'types';

export type SelectedItemProps = {
  selectedItems: GenericValueLabel[];
  onClick: (value: number | string) => void;
};

export const MultiSelectItems: React.FC<SelectedItemProps> = ({ selectedItems, onClick }) => {
  return (
    <Box display='inline' data-testid='multi-select-items'>
      {selectedItems?.map((filter: GenericValueLabel) => (
        <Button
          data-testid='multiselect-item'
          key={filter.value}
          float='left'
          mt={2}
          mr={2}
          py={2}
          pr={9}
          pl={2}
          minWidth='10px !important'
          height={6}
          variant='secondary'
          justifySelf='left'
          fontSize='1.3rem'
          rightIcon={<TiTimes />}
          onClick={() => onClick(filter.value)}
        >
          <Text
            color={COLOURS.black}
            fontSize='0.75rem'
            fontWeight='400 !important'
            isTruncated
            maxWidth='220px'
            size='xs'
          >
            {filter.label}
          </Text>
        </Button>
      ))}
    </Box>
  );
};
